import { SupportedPlugins } from '../providers/providers.types';

export default {
    hasConsent,
    grantConsent,
    revokeConsent,
    openConsents
};

function hasConsent(name: SupportedPlugins) {
  const consensId = `consent.${name}`;
  const hasSavedConsens = localStorage.getItem(consensId) === 'true';
  return hasSavedConsens;
}

function grantConsent(name: SupportedPlugins) {
  localStorage.setItem(`consent.${name}`, 'true');
}

function revokeConsent(name: SupportedPlugins) {
  localStorage.setItem(`consent.${name}`, 'false');
}

function openConsents() {
  alert(`
Facebook: ${hasConsent('facebook')}
Twitter: ${hasConsent('twitter')}
Instagram: ${hasConsent('instagram')}
`);
}
